import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import Overrides from "./Overrides";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("ahg-overrides")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Overrides />
		</ThemeProvider>
	</StrictMode>
);
